// extracted by mini-css-extract-plugin
export default {"notify":"List_notify__ycfcm","container":"List_container__dxCQO"};